export default __webpack_public_path__ + "static/media/Cover (3)2.4be75172.png";